export interface Pack {
  id: number;
  lang: string;
  version: number;
  status: PackStatus;
  checksum: string | null;
  sizeBytes: number;
  lastDownloadDate: Date;
  versionLimit: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export enum PackStatus {
  Pending = 0,
  Released = 1,
  Deprecated = 2,
}
